import tw from "twin.macro";

const DarkContainer = tw.div`bg-turquoise-light shadow-lg`;

export default DarkContainer;
